import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const BoxTabs = lib.styled.div`
  display: flex;
  flex-direction: row!important;
  align-items: center;
  justify-content: space-between;

  .active {
    background: linear-gradient(50.28deg, #67C2E4 2.79%, #0C4BBC 73.37%);
    border: 0px;

    span {
      color: ${colors.white};
      letter-spacing: 0.05em;
      font-weight: 800;
    }
  }
`;

export const ItemTab = lib.styled.div`
  display: flex;
  flex-direction: row!important;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.lightGray06};
  width: 60px;
  height: 26px;
  border-radius: 30px;
  padding: 0px 8px 0px 8px;
  cursor: pointer;
  margin-right: 8px;

  span:lang(de) {
    font-size: 10px;
  }

  span:lang(es) {
    font-size: 12px;
  }

  span:lang(pt) {
    font-size: 9px;
  }

  span {
    font-size: ${fonts.default}px;
    color: ${colors.darkGray05};
  }

`;
